import keyboardSilhouetteLayouts from "./keyboardSilhouetteLayouts";

const sortSilhouetteKeys = (keys) => {
    const rows = [];
    [...(keys || [])]
        .sort((a, b) => parseFloat(a.top) - parseFloat(b.top) || parseFloat(a.left) - parseFloat(b.left))
        .forEach((key) => {
            const top = parseFloat(key.top);
            const row = rows.find((candidate) => Math.abs(candidate.top - top) < 3);
            if (row) {
                row.keys.push(key);
                row.top = Math.min(row.top, top);
            } else {
                rows.push({top, keys: [key]});
            }
        });

    return rows
        .sort((a, b) => a.top - b.top)
        .flatMap((row) => row.keys.sort((a, b) => parseFloat(a.left) - parseFloat(b.left)));
};

const buildEighteenHundredPreviewKeys = () => (
    sortSilhouetteKeys(keyboardSilhouetteLayouts.eighteenhundred.keys)
        .filter((_, index) => ![13, 14, 15, 16, 17].includes(index))
);

const buildLayoutKeys = (rows, options = {}) => {
    const marginX = 1.7;
    const marginY = 5.8;
    const keyGap = options.keyGap ?? 0.08;
    const rowGap = options.rowGap ?? 1.4;
    const keyHeight = (100 - (marginY * 2) - (rowGap * (rows.length - 1))) / rows.length;
    const maxUnits = Math.max(...rows.map((row) => row.reduce((sum, key, index) => (
        sum + key.width + (key.gapBefore || 0) + (index > 0 ? keyGap : 0)
    ), 0)));

    return rows.flatMap((row, rowIndex) => {
        const unitWidth = (100 - (marginX * 2)) / maxUnits;
        let cursor = marginX;

        return row.map((key, index) => {
            cursor += ((index > 0 ? keyGap : 0) + (key.gapBefore || 0)) * unitWidth;
            const style = {
                left: `${cursor.toFixed(5)}%`,
                top: `${(marginY + (rowIndex * (keyHeight + rowGap))).toFixed(5)}%`,
                width: `${(key.width * unitWidth).toFixed(5)}%`,
                height: `${keyHeight.toFixed(5)}%`,
            };
            cursor += key.width * unitWidth;
            return style;
        });
    });
};

const unitRows = [
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1],
    [1.5, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.5, 1],
    [1.75, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2.33, 1],
    [2.25, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.83, 1, 1],
    [1.25, 1.25, 1.25, 5.9, 1.25, 1.25, 1.25, 1, 1, 1],
].map((row) => row.map((key) => (typeof key === "number" ? {width: key} : key)));

const fiftyUnitRows = [
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.3],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2.3],
    [1.6, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.7, 1],
    [{width: 1, gapBefore: 1.2}, 1, 1, 5.2, 1, 1, 1, 1],
].map((row) => row.map((key) => (typeof key === "number" ? {width: key} : key)));

const keyboardCustomLayouts = {
    eighteenhundred: {
        ...keyboardSilhouetteLayouts.eighteenhundred,
        previewKeys: buildEighteenHundredPreviewKeys(),
    },
    fifty: {
        width: "380.0px",
        height: "109.47px",
        ratio: "380.000000/109.473684",
        plateX: "1.47368%",
        plateY: "5.11538%",
        keys: buildLayoutKeys(fiftyUnitRows, {keyGap: 0.18, rowGap: 3}),
    },
    sixtyfive: {
        width: "412.0px",
        height: "142.0px",
        ratio: "412.000000/142.000000",
        plateX: "1.35922%",
        plateY: "3.94366%",
        keys: buildLayoutKeys(unitRows),
        previewKeys: buildLayoutKeys(unitRows, {keyGap: 0.16, rowGap: 2.8}),
    },
};

export default keyboardCustomLayouts;
